import { Alert, Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { HeaderTitle } from '../../common/HeaderTitle'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { useMojeDane } from '../../../api/domain/osoby/queries/useMojeDane.jsx'
import { useZmien2FA } from '../../../api/domain/osoby/mutations/useZmien2FA.jsx'

const ViewMojeKonto = () => {
    const storedUser = useSelector((state) => state?.user?.user || {})
    const role = useSelector((state) => state?.user?.role)
    const kcId = useSelector((state) => state?.user?.user?.sub)
    const { data } = useMojeDane(Boolean(kcId), kcId)
    const user = { ...storedUser, ...(data || {}) }
    const zmien2FA = useZmien2FA()

    const userId = user?.user_id || user?.id || ''
    const displayLogin =
        user?.email && user?.preferred_username
            ? `${user.email} / ${user.preferred_username}`
            : user?.email || user?.preferred_username || ''
    const displayName =
        [user?.imie, user?.nazwisko].filter(Boolean).join(' ') ||
        user?.name ||
        ''
    const is2FAEnabled = user?.czy_2fa === 'Tak'

    const renderInfoRow = (label, content, withDivider = true) => (
        <>
            <Row className={'me-5 align-items-center'}>
                <Col xs={12} md={4} className='text-start'>
                    <div className={'fw-bold text-start'}>{label}</div>
                </Col>
                <Col xs={12} md={8} className='text-start text-md-end'>
                    <div className={'text-start text-md-end'}>{content}</div>
                </Col>
            </Row>
            {withDivider && <hr />}
        </>
    )

    return (
        <>
            <HeaderTitle size={'h2'} nav={true} destination={'/'} title={'Moje dane'} />
            <Container>
                <HeaderTitle
                    nav={false}
                    size={'h3'}
                    title={'Dane zalogowanego użytkownika'}
                />
            </Container>
            <Container>
                <Card>
                    <Card.Body>
                        {renderInfoRow('ID konta użytkownika:', userId)}
                        {renderInfoRow('Email/login użytkownika:', displayLogin)}
                        {renderInfoRow('Imię i nazwisko:', displayName)}
                        {user?.czy_operator_ad !== 'Tak' &&
                            renderInfoRow(
                                'Zmień imię i nazwisko:',
                                <LinkContainer to='/uzytkownik/zmiana-danych'>
                                    <Button>Zmiana danych</Button>
                                </LinkContainer>
                            )}
                        {renderInfoRow('Telefon:', user?.telefon || '')}
                        {role === 'wp' && (
                            <>
                                {renderInfoRow(
                                    'Zmień hasło:',
                                    <LinkContainer to='/uzytkownik/zmiana-hasla'>
                                        <Button>Zmiana hasła</Button>
                                    </LinkContainer>
                                )}
                                <Alert variant={'info'} className={'p-2'}>
                                    Pamiętaj: włączenie uwierzytelniania
                                    dwuskładnikowego automatycznie wyloguje Cię z
                                    systemu i przeniesie do okna z kodem QR.
                                    Operacja musi zostać ukończona - dopiero wtedy
                                    będziesz miał możliwość zalogowania się i
                                    wyłączenia poniższej opcji.
                                </Alert>
                                {renderInfoRow(
                                    'Uwierzytelnienie dwuskładnikowe (2FA)',
                                    <div className='d-inline-flex align-items-center gap-2'>
                                        <Form.Check
                                            disabled={zmien2FA.isPending}
                                            onChange={() => zmien2FA.mutate()}
                                            type='switch'
                                            id='konto_2fa_switch'
                                            label=''
                                            className='mb-0'
                                            checked={is2FAEnabled}
                                        />
                                        <span>Włącz/Wyłącz</span>
                                    </div>
                                )}
                            </>
                        )}
                        {renderInfoRow(
                            'Lista Twoich uprawnień',
                            <Link className={'float-end'} to='/uzytkownik/moje-uprawnienia'>
                                Przejdź do listy uprawnień
                            </Link>,
                            false
                        )}
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}

export default ViewMojeKonto
